import { Outlet } from 'react-router';
import { LoginPromptComponent } from '@vivli/features/authentication/components';
import { NotFoundComponent } from '@vivli/shared/components';
import { useActiveUserContext, useAuthServiceContext } from '@vivli/core/infrastructure/context';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';

interface ProtectedRouteProps {
    requiredPermissions?: PermissionsEnum[];
}

export const ProtectedRoute = ({ requiredPermissions }: ProtectedRouteProps = {}) => {
    const { login } = useAuthServiceContext();
    const { user, hasAnyPermission } = useActiveUserContext();

    if (!user) {
        return <LoginPromptComponent login={login} />;
    }

    if (requiredPermissions && !hasAnyPermission(requiredPermissions)) {
        return <NotFoundComponent />;
    }

    return <Outlet />;
};
